import FormContainer from "@app/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";
import {CommonErrorModal} from "@app/components/modals/CommonErrorModal"
import {CommonSelectModal, CommonModal} from "@app/components/modals/CommonModal"
import { Button, useModal } from "@shortsworks/ui";
import {useGetWidgets, WidgetData, useGetAccountAccessKey} from "@shortsworks/user-api"
import { LoaderCircle } from "lucide-react";
import { Suspense, useEffect } from "react";

interface WidgetSelectorProps {
  selectedWidgetId: any;
  onChangeSelectedWidgetId: any;
}

// 첫번째 위젯 아이디 선택, 없을 경우 새로운 위젯으로 표시
export const WidgetSelector = ({
  selectedWidgetId,
  onChangeSelectedWidgetId,
}: WidgetSelectorProps) => {
  const { showModal } = useModal();
  const { data: widgetsData, isSuccess: isSuccessGetWidgets } = useGetWidgets();
  const isWidgetsDataEmpty = widgetsData?.data.length === 0;
  const {data: accessKeyData, isSuccess: isSuccessGetAccessKey} = useGetAccountAccessKey();
  if (!isSuccessGetWidgets) {
    return;
  }

  // schema를 함수형태로 작성하도록 관리
  const WidgetsSchema: FormFieldSchema[] = [
    {
      type: FormFieldType.Select,
      label: "위젯 목록",
      id: "widgetId",
      layout: "vertical",
      behavior: {
        disabled: isWidgetsDataEmpty
      },
      options: [
        ...widgetsData.data.map((widget) => {
          return {
            label: widget.name,
            value: widget.id,
          };
        }),
      ],
    },
  ];

  const handleClickCreateTempWidget = async () => {
    if(!selectedWidgetId) {
      return showModal(CommonErrorModal, {title: "현재 새로운 위젯입니다."});
    }
    const modalResult = await showModal(CommonSelectModal, {title: "위젯 생성", description: "새로운 위젯을 추가하시겠습니까? 설정 정보는 저장되지 않습니다."}).promise();
    if(!modalResult.value) {
      return;
    }

    return onChangeSelectedWidgetId(null);
  };
  const handleCopyWidgetScript = () => {
      if(!isSuccessGetAccessKey) {
        return showModal(CommonErrorModal, {title: "액세스 키를 가져올 수 없습니다. 다시 시도해주세요."});
      }
      if(!selectedWidgetId) {
        return showModal(CommonErrorModal, {title: "선택된 위젯이 없습니다."});
      }
      navigator.clipboard.writeText(`<shorts-works access-key="${accessKeyData.data.accessKey}" widget-id="${selectedWidgetId}" /> `);
      return showModal(CommonModal, {title: "위젯이 복사되었습니다."});
  }

  const WidgetSelectorFormField = () => {
    const { schemas, form, formValues } = useFormWithSchema({
      formSchemas: WidgetsSchema,
      defaultFormValues: {
        widgetId: selectedWidgetId,
      },
    });

    // 위젯 변경이 경고
    useEffect(() => {
    //   (async () => {
        // const modalResult = showModal(CommonSelectModal, {title: "위젯 변경 시, 변경 사항이 저장되지 않았습니다."}).promise();
        // if(!modalResult.value) { return; }
      // })();
      return onChangeSelectedWidgetId(formValues.widgetId);
    }, [formValues]);

    return (
      <Suspense>
        <FormContainer schemas={schemas} form={form} />
      </Suspense>
    );
  };

  return (
    <div className="flex flex-row items-end gap-2">
      <div className="w-32 mb-3">
        <WidgetSelectorFormField />
      </div>
      <Button onClick={handleClickCreateTempWidget} className="mb-3">
        추가
      </Button>
      <Button variant="outline" onClick={handleCopyWidgetScript} className="mb-3">
        복사
      </Button>
    </div>
  );
};
